import { registerPlugin } from '@capacitor/core';

import type { IosExternalLinkPlugin } from './definitions';

const IosExternalLink = registerPlugin<IosExternalLinkPlugin>('IosExternalLink', {
  web: () => import('./web').then(m => new m.IosExternalLinkWeb()),
});

export * from './definitions';
export { IosExternalLink };
